import { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext({
  theme: "_light",
  toggleTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
  // Load theme safely
  let savedTheme = localStorage.getItem("theme");

  // Ensure only valid themes are used
  if (savedTheme !== "_light" && savedTheme !== "_dark") {
    savedTheme = "_light";
    localStorage.setItem("theme", "_light");
  }

  const [theme, setTheme] = useState(savedTheme);

  // The new CSS custom property system (src/styles/theme.css) reads a
  // `data-theme="light"|"dark"` attribute on <html>; the legacy `_light`/
  // `_dark` class on <body>/.app is kept as-is alongside it so nothing
  // that already depends on those classes breaks.
  const dataThemeValue = (value) => (value === "_dark" ? "dark" : "light");

  const toggleTheme = () => {
    const newTheme = theme === "_light" ? "_dark" : "_light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.body.className = newTheme; // Apply immediately
    document.documentElement.setAttribute("data-theme", dataThemeValue(newTheme));
  };

  // Run on first load + whenever theme changes
  useEffect(() => {
    document.body.className = theme;
    document.documentElement.setAttribute("data-theme", dataThemeValue(theme));
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
